/**
 * Elflink Footer — mobile accordion + newsletter feedback
 * Desktop (≥860px): panels always open; triggers are non-interactive via CSS
 */
(function () {
  var MQ = window.matchMedia("(min-width: 860px)");
  var DEFAULT_FEEDBACK_TTL = 8000;

  function isDesktop() {
    return MQ.matches;
  }

  function closeAll(root, except) {
    root.querySelectorAll("[data-eft-col]").forEach(function (col) {
      if (col === except) return;
      col.classList.remove("is-open");
      var btn = col.querySelector("[data-eft-trigger]");
      if (btn) btn.setAttribute("aria-expanded", "false");
    });
  }

  function syncDesktop(root) {
    if (!isDesktop()) return;
    root.querySelectorAll("[data-eft-col]").forEach(function (col) {
      col.classList.add("is-open");
      var btn = col.querySelector("[data-eft-trigger]");
      if (btn) btn.setAttribute("aria-expanded", "true");
    });
  }

  function isNewsletterReturnUrl() {
    var params = new URLSearchParams(window.location.search);
    return (
      params.get("form_type") === "customer" ||
      params.has("customer_posted") ||
      /(?:^|[?&])form_type=customer(?:&|$)/.test(window.location.search)
    );
  }

  function clearNewsletterReturnParams() {
    if (!isNewsletterReturnUrl()) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete("form_type");
      url.searchParams.delete("customer_posted");
      url.searchParams.delete("contact_posted");
      var next = url.pathname + (url.searchParams.toString() ? "?" + url.searchParams.toString() : "") + url.hash;
      window.history.replaceState({}, "", next);
    } catch (e) {
      /* ignore */
    }
  }

  function focusStatus(el) {
    if (!el) return;
    window.requestAnimationFrame(function () {
      try {
        el.focus({ preventScroll: true });
      } catch (e) {
        /* ignore */
      }
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }

  function readTtl(el, fallbackEl) {
    var raw =
      (el && el.getAttribute("data-eft-feedback-ttl")) ||
      (fallbackEl && fallbackEl.getAttribute("data-feedback-ttl")) ||
      "";
    var ttl = parseInt(raw, 10);
    if (!ttl || ttl < 3000) return DEFAULT_FEEDBACK_TTL;
    return ttl;
  }

  function scheduleFeedbackDismiss(status, ttl) {
    if (!status || status.dataset.eftDismissScheduled === "1") return;
    status.dataset.eftDismissScheduled = "1";
    var wait = typeof ttl === "number" ? ttl : DEFAULT_FEEDBACK_TTL;
    window.setTimeout(function () {
      if (!status || !status.parentNode) return;
      status.classList.add("is-dismissing");
      window.setTimeout(function () {
        if (status && status.parentNode) status.parentNode.removeChild(status);
      }, 320);
    }, wait);
  }

  function ensureFeedbackBanner(form, options) {
    if (!form) return null;
    var existing = form.querySelector("[data-eft-newsletter-success]");
    if (existing) existing.parentNode.removeChild(existing);

    var banner = document.createElement("div");
    banner.className = "elfink-footer__status elfink-footer__status--success";
    banner.setAttribute("role", "status");
    banner.setAttribute("tabindex", "-1");
    banner.setAttribute("data-eft-newsletter-success", "");
    if (options.already) banner.setAttribute("data-eft-newsletter-already", "");
    if (options.scroll) banner.setAttribute("data-eft-newsletter-scroll", "");
    banner.setAttribute("data-eft-feedback-ttl", String(options.ttl || DEFAULT_FEEDBACK_TTL));

    var title = document.createElement("p");
    title.className = "elfink-footer__status-title";
    title.textContent = options.title || "";
    banner.appendChild(title);

    if (options.note) {
      var note = document.createElement("p");
      note.className = "elfink-footer__status-note";
      note.textContent = options.note;
      banner.appendChild(note);
    }

    var fields = form.querySelector("[data-eft-newsletter-fields]");
    if (fields) form.insertBefore(banner, fields);
    else form.insertBefore(banner, form.firstChild);

    var email = form.querySelector('input[type="email"]');
    if (email) email.value = "";

    return banner;
  }

  function showFeedbackMessage(form, options) {
    var banner = ensureFeedbackBanner(form, options);
    if (!banner) return;
    if (options.scroll) focusStatus(banner);
    scheduleFeedbackDismiss(banner, options.ttl);
  }

  function detectAlreadySubscribed(root) {
    var success = root.querySelector("[data-eft-newsletter-success]");
    if (success) return false;

    var fields = root.querySelector("[data-eft-newsletter-fields]");
    var form = fields && fields.closest("form");
    if (!form || !fields) return false;

    var email = form.querySelector('input[name="contact[email]"]');
    if (!email || !String(email.value || "").trim()) return false;
    if (!isNewsletterReturnUrl()) return false;

    var ttl = readTtl(null, fields);
    showFeedbackMessage(form, {
      title:
        fields.getAttribute("data-already-message") ||
        "This email is already subscribed — no new welcome email will be sent.",
      already: true,
      scroll: true,
      ttl: ttl
    });
    clearNewsletterReturnParams();
    return true;
  }

  function bindNewsletterValidation(form, fields) {
    if (!form || form.dataset.eftNewsReady === "1") return;
    form.dataset.eftNewsReady = "1";

    var email = form.querySelector('input[type="email"]');
    var clientError = form.querySelector("[data-eft-newsletter-client-error]");
    var msg =
      (fields && fields.getAttribute("data-email-error")) ||
      "Please enter a valid email address.";
    var alreadyMsg =
      (fields && fields.getAttribute("data-already-message")) ||
      "This email is already subscribed — no new welcome email will be sent.";
    var successTitle =
      (fields && fields.getAttribute("data-success-title")) || "You're on the list!";
    var successNote = (fields && fields.getAttribute("data-success-note")) || "";
    var ttl = readTtl(null, fields);

    function setInvalid(show) {
      if (email) {
        email.classList.toggle("is-invalid", show);
        email.setAttribute("aria-invalid", show ? "true" : "false");
      }
      if (clientError) {
        clientError.hidden = !show;
      }
    }

    function validateEmailValue(value) {
      if (!value || !String(value).trim()) return false;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
    }

    if (email) {
      email.addEventListener("invalid", function (e) {
        e.preventDefault();
        email.setCustomValidity(msg);
        setInvalid(true);
      });

      email.addEventListener("input", function () {
        email.setCustomValidity("");
        setInvalid(false);
      });
    }

    form.addEventListener("submit", function (e) {
      if (!email) return;
      email.setCustomValidity("");
      if (!validateEmailValue(email.value)) {
        e.preventDefault();
        email.setCustomValidity(msg);
        setInvalid(true);
        email.focus();
        return;
      }

      // Local HTML preview only
      if (form.getAttribute("data-eft-preview") === "1") {
        e.preventDefault();
        var key = "eft-preview-subs";
        var list = [];
        try {
          list = JSON.parse(sessionStorage.getItem(key) || "[]");
        } catch (err) {
          list = [];
        }
        var normalized = String(email.value || "").trim().toLowerCase();
        if (list.indexOf(normalized) !== -1) {
          showFeedbackMessage(form, {
            title: alreadyMsg,
            already: true,
            scroll: true,
            ttl: ttl
          });
          return;
        }
        list.push(normalized);
        try {
          sessionStorage.setItem(key, JSON.stringify(list));
        } catch (err2) {
          /* ignore */
        }
        showFeedbackMessage(form, {
          title: successTitle,
          note: successNote,
          scroll: true,
          ttl: ttl
        });
      }
    });
  }

  function initNewsletter(root) {
    if (detectAlreadySubscribed(root)) {
      var formAfter = root.querySelector("form.elfink-footer__form");
      var fieldsAfter = root.querySelector("[data-eft-newsletter-fields]");
      bindNewsletterValidation(formAfter, fieldsAfter);
      return;
    }

    var success = root.querySelector("[data-eft-newsletter-success]");
    if (success) {
      if (success.hasAttribute("data-eft-newsletter-scroll") || isNewsletterReturnUrl()) {
        focusStatus(success);
        clearNewsletterReturnParams();
      }
      scheduleFeedbackDismiss(success, readTtl(success, root.querySelector("[data-eft-newsletter-fields]")));
    }

    var fields = root.querySelector("[data-eft-newsletter-fields]");
    var form = fields && fields.closest("form");
    bindNewsletterValidation(form, fields);
  }

  function init(root) {
    if (!root || root.dataset.eftReady === "1") return;
    root.dataset.eftReady = "1";

    root.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-eft-trigger]");
      if (!btn || !root.contains(btn)) return;
      if (isDesktop()) return;

      e.preventDefault();
      var col = btn.closest("[data-eft-col]");
      if (!col) return;

      var open = !col.classList.contains("is-open");
      if (open) {
        closeAll(root, col);
        col.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
      } else {
        col.classList.remove("is-open");
        btn.setAttribute("aria-expanded", "false");
      }
    });

    syncDesktop(root);
    initNewsletter(root);
  }

  function boot() {
    document.querySelectorAll("[data-elfink-footer]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  if (MQ.addEventListener) {
    MQ.addEventListener("change", function () {
      document.querySelectorAll("[data-elfink-footer]").forEach(syncDesktop);
    });
  } else if (MQ.addListener) {
    MQ.addListener(function () {
      document.querySelectorAll("[data-elfink-footer]").forEach(syncDesktop);
    });
  }

  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target && e.target.querySelector
      ? e.target.querySelector("[data-elfink-footer]")
      : null;
    if (root) {
      root.dataset.eftReady = "";
      init(root);
    }
  });
})();
